import React from 'react';

import Link from 'next/link';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import ThankParticipants from '@components/lpc/Pot/AmountModule/ThankParticipants/ThankParticipants';
import { personRoles } from '@models/PotModel/personRoles';
import { potType } from '@propTypes/potTypes';
import { getRoute, ROUTE } from '@services/http/Route';

import css from './BeneficiaryMobileBloc.module.scss';

type BeneficiaryMobileBlocProps = {
    pot: potType;
};

const BeneficiaryMobileBloc = ({ pot }: BeneficiaryMobileBlocProps) => {
    const { t } = useTranslateLpc(['lpc-pot']);

    return (
        <>
            <div className={css.beneficiary_bloc}>
                <div className={css.beneficiary_bloc__flex_box}>
                    <ThankParticipants
                        buttonVariant={'white'}
                        isVisible={pot.personRole === personRoles.BENEFICIARY}
                        potRef={pot.uniq}
                        wordingCta={t('amount.cta.thank-participants')}
                        potTitle={pot.title}
                        customClass={css.beneficiary_bloc__flex_box__thank}
                        showIcon={true}
                    />
                    <Link href={getRoute(ROUTE.LPC.POT.POT, pot.uniq, ROUTE.LPC.POT.SPENDING)} legacyBehavior>
                        <Button isDisabled={pot.isFrozenAccount} variant={'primary'}>
                            <div>{t('amount.cta.spend')}</div>
                        </Button>
                    </Link>
                </div>
            </div>
        </>
    );
};

export default BeneficiaryMobileBloc;
